import { useQuery } from "@tanstack/react-query";

import { getSoilSightProject } from "services";

import { useIsAuthenticated } from "utils";

import { GET_SOIL_SIGHT_PROJECT } from "consts";

import { SoilSightProjectResponse } from "models";

export const useGetSoilSightProject = (soilSightProjectId: string) => {
  const isAuthenticated = useIsAuthenticated();

  return useQuery<SoilSightProjectResponse>({
    queryKey: [GET_SOIL_SIGHT_PROJECT, soilSightProjectId],
    queryFn: () => getSoilSightProject(soilSightProjectId),
    staleTime: 1000 * 60 * 5, // 5 minutes
    enabled: isAuthenticated && !!soilSightProjectId, // only fetch with a real id
  });
};
